<template>
  <div class="app-wrapper">
    <sidebar v-if="!$route.meta.hideSidebar" />
    <div class="con-wrapper">
      <header-Top  v-if="!$route.meta.hideHeader" />
      <bread-crumb v-if="!$route.meta.hideBread" />
      <app-Main v-if="$store.state.busId" id="vipMainCon" />
    </div>
  </div>
</template>
<script>
  import headerTop from 'views/layout/headerTop';
  import sidebar from 'views/layout/sidebar';
  import appMain from 'views/layout/appMain';
  import breadCrumb from './breadCrumb.vue';

  export default {
    name: 'layOut',
    components: {
      headerTop,
      sidebar,
      appMain,
      breadCrumb
    },
    computed: {}
  };
</script>
<style lang="less" scoped>
  .app-wrapper {
    display: flex;
    height: 100%;
    width: 100%;
  }

  .con-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
</style>
